module.exports = __webpack_public_path__ + "img/teacher2.ad4f2463.png";